module.exports = __webpack_public_path__ + "assets/img/tx388_2.52f068ae.jpg";